import { render, staticRenderFns } from "./ChatEscalation.vue?vue&type=template&id=5fe4776b&"
import script from "./ChatEscalation.vue?vue&type=script&lang=ts&"
export * from "./ChatEscalation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports